// Shared colour + badge vocabulary for capture analysis rendering.
//
// These lived inline in the coach detail page. The analysis is now rendered in
// three places (coach detail, a student's own view, and a public share link), so
// they live here instead — otherwise a score that reads green for the coach can
// render amber on the shared page and the coach looks inconsistent to a client.

export const isLightTheme = () =>
  typeof document !== "undefined" && document.documentElement.classList.contains("light");

/** Score (0-100) → semantic colour. */
export function scoreColor(s) {
  const light = isLightTheme();
  if (s == null) return light ? "#6B7280" : "#52525b";
  if (s >= 80) return light ? "#15803D" : "#00ff88";
  if (s >= 60) return light ? "#B45309" : "#ffab00";
  return light ? "#B91C1C" : "#ff3b30";
}

export function severityColors() {
  return isLightTheme()
    ? { high: "#B91C1C", medium: "#B45309", low: "#0284C7" }
    : { high: "#ff3b30", medium: "#ffab00", low: "#38BDF8" };
}

const STROKE_BADGES = {
  dink: "Di",
  drive: "Dr",
  drop: "Dp",
  volley: "V",
  overhead: "O",
  serve: "S",
};

/** Two-letter badge for the per-rep sparkline. */
export function strokeBadge(t) {
  return STROKE_BADGES[t] || null;
}

/** Colours used by the AI callouts for best / worst / other reps. */
export function calloutColor(label) {
  if (label === "best") return "#00ff88";
  if (label === "worst") return "#ff3b30";
  return "#ffab00";
}
